import { EventBus } from "../../../eventbus";
import { addLeadingZero } from "../../../functions/HelperFuncs";
import { download } from "../../../functions/download";
import { userHasAllRights } from "../../../functions/userRights";
import { editableExtensions } from "../../../config";
import i18n from "../../../functions/i18next";

export default {
  props: {
    realFile: {
      type: Object,
    },
  },
  data() {
    return {
      isDownloading: false,
      showDownloadOptions: false,
      actions: [],
    };
  },
  created() {
    if (this.realFile) {
      this.setActions();
    }

    EventBus.$on(`download--done`, (id) => {
      if (this.realFile.id === id) {
        this.isDownloading = false;
      }
    });
  },
  methods: {
    getDownloadBtn() {
      if (this.realFile.extension !== "url" && !this.realFile.location) {
        return this.realFile.dimensions
          ? {
              name: i18n.tc("common.download", 1),
              icon: "download",
              color: "overlay",
              rights: ["download_files"],
              options: [
                {
                  name: i18n.t("common.large"),
                  icon: "download",
                  altText: this.realFile.dimensions,
                  func: (e) => {
                    this.downloadFile(e);
                  },
                },
                {
                  name: i18n.t("common.medium"),
                  icon: "download",
                  altText: "",
                  func: (e) => {
                    this.downloadFile(e, ["resforweb"]);
                  },
                },
                {
                  name: i18n.t("common.custom"),
                  icon: "crop",
                  altText: "",
                  func: () => {
                    this.crop();
                  },
                },
              ],
            }
          : {
              name: i18n.tc("common.download", 1),
              icon: "download",
              color: "overlay",
              rights: ["download_files"],
              func: (e) => {
                this.downloadFile(e);
              },
            };
      }

      return null;
    },

    setActions() {
      this.actions = [
        this.getDownloadBtn(),
        {
          name: i18n.t("transfer.transfer"),
          rights: ["transfer_files"],
          icon: "transfer",
          color: "overlay",
          half: true,
          func: () => {
            this.transfer();
          },
        },
        {
          name: i18n.t("collection.collect"),
          rights: ["collect"],
          icon: "collect",
          color: "overlay",
          half: true,
          func: () => {
            this.collect();
          },
        },
      ];

      if (this.canEdit()) {
        this.actions.push({
          name: i18n.t("common.edit"),
          rights: [],
          icon: "edit",
          color: "white",

          func: () => {
            this.showEdit();
          },
        });
      } else {
        this.actions.push({
          name: i18n.t("common.view"),
          rights: [],
          icon: "info--outline",
          color: "white",

          func: () => {
            this.showFull();
          },
        });
      }
    },
    canEdit() {
      let present = false;

      editableExtensions.forEach((ext) => {
        if (this.realFile.extension === ext) {
          present = true;
        }
      });

      return present;
    },
    transfer() {
      this.openRightSidebar("transfer", this.realFile);
    },
    collect() {
      //this.$root.$refs.navigation_sidebar.showCollectedBadge();

      //add file to selected files
      this.$store.state.transferItems = {
        selectedFiles: [this.realFile],
        selectedFolders: [],
        collection: {},
      };

      this.openRightSidebar("collect");
    },
    openRightSidebar(id, data) {
      EventBus.$emit("closeallactions");

      EventBus.$emit(`right-sidebar-show`, {
        id: id,
        data: data,
      });
    },
    showFull() {
      this.$router.push(
        `/${this.$store.state.company}/${
          this.realFile.myspace ? "myspace" : "home"
        }/expanded/${this.realFile.folder_id}/${
          this.realFile.file_id ? this.realFile.file_id : this.realFile.id
        }/detail`
      );
    },
    showEdit() {
      this.$router.push(
        `/${this.$store.state.company}/${
          this.realFile.myspace ? "myspace" : "home"
        }/expanded/${this.realFile.folder_id}/${
          this.realFile.file_id ? this.realFile.file_id : this.realFile.id
        }/detail`
      );
    },
    downloadFile(e, specialAttrs = []) {
      e.preventDefault();

      if (!this.isDownloading) {
        this.isDownloading = true;

        download(
          {
            type: "file",
            item: this.realFile,
            specialAttrs,
          },
          this
        );
      }
    },

    crop() {
      this.$router.push(
        `/${this.$store.state.company}/${
          this.realFile.myspace ? "myspace" : "home"
        }/expanded/${this.realFile.folder_id}/${
          this.realFile.file_id ? this.realFile.file_id : this.realFile.id
        }/edit`
      );
    },
    halfAction(action, index) {
      const prevItem = this.getActions[index - 1];
      const nextItem = this.getActions[index + 1];
      let halfItem = action.half;

      if (halfItem) {
        if (prevItem) {
          if (prevItem.half) {
            halfItem = true;
          }
        }

        if (nextItem) {
          if (nextItem.half) {
            halfItem = true;
          }
        }
      }

      return halfItem;
    },
  },
  computed: {
    getActions() {
      return this.actions.filter((action) => {
        if (action !== null) {
          return userHasAllRights(action.rights, this);
        } else {
          return false;
        }
      });
    },
    dateAdded() {
      if (this.realFile) {
        const date = new Date(this.realFile.created_at);

        return `${addLeadingZero(date.getDate())}/${addLeadingZero(
          date.getMonth() + 1
        )}/${date.getFullYear()}`;
      }

      return false;
    },
  },
  watch: {
    realFile() {
      this.setActions();
    },
  },
};
